import React from 'react';
import { Link } from 'react-router-dom';
import './Placements.css';
import OptimizedImage from './OptimizedImage';
import onPropertyImg from 'url:../../assets-optimized/redesign/placement/on-property.jpg';
import onPropertyImgavif from 'url:../../assets-optimized/redesign/placement/on-property.avif';
import onPropertyImgwebp from 'url:../../assets-optimized/redesign/placement/on-property.webp';
import ownedDigitalImg from 'url:../../assets-optimized/redesign/placement/owned-digital.jpg';
import ownedDigitalImgavif from 'url:../../assets-optimized/redesign/placement/owned-digital.avif';
import ownedDigitalImgwebp from 'url:../../assets-optimized/redesign/placement/owned-digital.webp';
import offsiteDigitalImg from 'url:../../assets-optimized/redesign/placement/offsite-digital.jpg';
import offsiteDigitalImgavif from 'url:../../assets-optimized/redesign/placement/offsite-digital.avif';
import offsiteDigitalImgwebp from 'url:../../assets-optimized/redesign/placement/offsite-digital.webp';
import ourPlacementsText from 'url:../../assets/redesign/text/our_placements.svg';
import ourPlacementsTextMobile from 'url:../../assets/redesign/text/our_placements_mobile.svg';

const ArrowButton = ({ to }) => (
  <Link to={to} className='placement-arrow-wrapper'>
    <div className='placement-arrow-btn'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48'
        height='48'
        viewBox='0 0 44 44'
        fill='none'
      >
        <path
          d='M13.6947 30.1437L29.6782 14.1602'
          stroke='#fff'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        ></path>
        <path
          d='M30.1404 30.4558L30.1404 13.7005L12.3724 13.7004'
          stroke='#fff'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        ></path>
      </svg>
    </div>
  </Link>
);

const Placements = () => {
  return (
    <section id='placements' className='redesign-placements'>
      <div className='placements-content'>
        <div className='placements-text'>
          <p className='all-caps'>ACTIVATE ACROSS THE GUEST JOURNEY</p>

          <p>
            Each guest journey is unique. Which means endless, customizable opportunities for your
            brand to make meaningful connections with your audience.
          </p>
        </div>
        <div className='placements-cards'>
          <div className='placement-card on-property'>
            <div className='card-image'>
              <OptimizedImage
                avif={onPropertyImgavif}
                webp={onPropertyImgwebp}
                fallback={onPropertyImg}
                alt='On-Property'
              />
            </div>
            <div className='card-content'>
              <h3>ON-PROPERTY</h3>
              <p>In-room screens. Real-world moments.</p>
              <ArrowButton to='/solutions/on-property' />
            </div>
          </div>
          <div className='placement-card owned-digital'>
            <div className='card-image'>
              <OptimizedImage
                avif={ownedDigitalImgavif}
                webp={ownedDigitalImgwebp}
                fallback={ownedDigitalImg}
                alt='Owned Digital'
              />
            </div>
            <div className='card-content'>
              <h3>OWNED DIGITAL</h3>
              <p>Where planning turns into action.</p>
              <ArrowButton to='/solutions/marriott-digital' />
            </div>
          </div>
          <div className='placement-card offsite-digital'>
            <div className='card-image'>
              <OptimizedImage
                avif={offsiteDigitalImgavif}
                webp={offsiteDigitalImgwebp}
                fallback={offsiteDigitalImg}
                alt='Offsite Digital'
              />
            </div>
            <div className='card-content'>
              <h3>OFFSITE DIGITAL</h3>
              <p>Follow travelers wherever attention moves.</p>
              <ArrowButton to='/solutions/offsite-digital' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Placements;
